module.exports = __webpack_public_path__ + "img/hv-harmonic-filters.1df600f1.jpg";